(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7889],{

/***/ 75336:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-get-member",
      function () {
        return __webpack_require__(54172);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ StyledFaqsHeader; },
/* harmony export */   "Ie": function() { return /* binding */ StyledWebFaqs; },
/* harmony export */   "s5": function() { return /* binding */ StyledFaqsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99655);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledFaqsSection = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledFaqsHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"), components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Heading2 */ .XJ, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"));
var StyledWebFaqs = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-73f69e31-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_200"));


/***/ }),

/***/ 29372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53307);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99655);
/* harmony import */ var _Faqs_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12109);




var Faqs = function(param) {
    var faqs = param.faqs, title = param.title, desc = param.desc, h3 = param.h3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs && faqs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsSection */ .s5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsHeader */ .$t, {
                    children: [
                        !h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                            editorial: true,
                            children: title
                        }),
                        h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                            editorial: true,
                            children: title
                        }),
                        desc && typeof desc === "object" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: desc
                        }),
                        typeof desc === "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: desc || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledWebFaqs */ .Ie, {
                    children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            renderComponent: faq.renderComponent,
                            question: faq.question,
                            answer: faq.answer,
                            anchor: faq.anchor,
                            active: faq.active
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Faqs);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 54172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ member_get_member; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ./components/marketingSite/shared/Faqs.tsx
var Faqs = __webpack_require__(29372);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/MGMComponent.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFaqsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5ec61da-0"
})(_templateObject(), (0,theme/* color */.$_)("white"));

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/features/MGMFeatures.styled.tsx

function MGMFeatures_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        " ",
        ";\n"
    ]);
    MGMFeatures_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n\n  p {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  display: grid;\n  gap: ",
        ";\n  grid-template-columns: minmax(0, 1fr);\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: 14px 14px 49px 14px;\n  text-align: left;\n  display: flex;\n  max-width: 23rem;\n  min-height: 34.5rem;\n  justify-self: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(145deg, #850e53, #7b57e4);\n  border-radius: 0.75rem 0.75rem 2rem 2rem;\n  padding: 0.3125rem 0.625rem 0;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  filter: drop-shadow(-2px 2px 2.27px #261a19)\n    drop-shadow(0px 2px 1.51px #261a19);\n  display: flex;\n  flex-direction: column;\n  margin-bottom: -30px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'MTG', Papyrus, serif;\n  margin: 0;\n  font-size: 1.4375rem;\n  line-height: 1;\n  letter-spacing: 0.05em;\n  padding: 7px 7px 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: ",
        ";\n  color: ",
        ";\n  background-image: linear-gradient(\n    180deg,\n    #15092f 0%,\n    #736f81 13.02%,\n    #686573 49.91%,\n    #1d1439 88.54%,\n    #1e076e 100%\n  );\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  box-shadow: inset 0 0 0 1px ",
        ";\n\n  img {\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 3px solid ",
        ";\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-top: -2px;\n\n  img {\n    display: block;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 3px 3px 7px;\n  border-radius: ",
        " ",
        " 0 0;\n  margin-top: -1px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  border-radius: 6px;\n  margin: 0;\n  font-style: italic;\n  font-weight: ",
        ";\n  line-height: 1.125;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  background-color: ",
        ";\n  box-shadow: inset -2px -2px 4px rgba(42, 42, 58, 0.15),\n    inset 2px 2px 2px rgba(42, 42, 58, 0.25);\n  padding: 10px 9px;\n  margin-top: 7px;\n  margin-left: 1px;\n  margin-right: 1px;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: ",
        ";\n  line-height: 1.25;\n  font-weight: ",
        ";\n\n  img {\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-0"
})(MGMFeatures_styled_templateObject(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl5"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-1"
})(_templateObject1(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"));
var StyledFeatures = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* screen */.sp)("lg"));
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-3"
})(_templateObject3(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* radius */.q0)("lg"));
var StyledCardInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-4"
})(_templateObject4());
var StyledCardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-5"
})(_templateObject5());
var StyledCardTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-a234a487-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* color */.$_)("midnight_700"));
var StyledCardImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-7"
})(_templateObject7(), (0,theme/* color */.$_)("midnight_100"));
var StyledCardMainContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-8"
})(_templateObject8(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("md"));
var StyledCardDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a234a487-9"
})(_templateObject9(), (0,theme/* color */.$_)("midnight_150"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledCardRewards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-10"
})(_templateObject10(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("mdlg"));
var StyledCardReward = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a234a487-11"
})(_templateObject11(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/features/MGMFeatures.tsx








var MGMFeatures = function() {
    var t = (0,useI18n/* useI18n */.Q)("member-get-member").t;
    var cards = [
        {
            title: t("member-get-member.how-it-works.referring-manfredite.title"),
            image: (0,paths/* getPublicPath */.A)("/images/memberGetMember/card1.png"),
            desc: t("member-get-member.how-it-works.referring-manfredite.desc"),
            rewards: [
                {
                    text: t("member-get-member.how-it-works.referring-manfredite.reward1"),
                    icon: (0,paths/* getPublicPath */.A)("/images/memberGetMember/merch.svg")
                },
                {
                    text: t("member-get-member.how-it-works.referring-manfredite.reward2"),
                    icon: (0,paths/* getPublicPath */.A)("/images/memberGetMember/fredcoins10.svg")
                },
                {
                    text: t("member-get-member.how-it-works.referring-manfredite.reward3"),
                    icon: (0,paths/* getPublicPath */.A)("/images/memberGetMember/fredcoins10.svg")
                }
            ]
        },
        {
            title: t("member-get-member.how-it-works.referring-company.title"),
            image: (0,paths/* getPublicPath */.A)("/images/memberGetMember/card2.png"),
            desc: t("member-get-member.how-it-works.referring-company.desc"),
            rewards: [
                {
                    text: t("member-get-member.how-it-works.referring-company.reward1"),
                    icon: (0,paths/* getPublicPath */.A)("/images/memberGetMember/fredcoins10.svg")
                },
                {
                    text: t("member-get-member.how-it-works.referring-company.reward2"),
                    icon: (0,paths/* getPublicPath */.A)("/images/memberGetMember/fredcoins5.svg")
                }
            ]
        },
        {
            title: t("member-get-member.how-it-works.referred-company.title"),
            image: (0,paths/* getPublicPath */.A)("/images/memberGetMember/card3.png"),
            desc: t("member-get-member.how-it-works.referred-company.desc"),
            rewards: [
                {
                    text: t("member-get-member.how-it-works.referred-company.reward1"),
                    icon: (0,paths/* getPublicPath */.A)("/images/memberGetMember/fredcoins5.svg")
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                id: "features",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                        as: "h2",
                        editorial: true,
                        children: t("member-get-member.how-it-works.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("member-get-member.how-it-works.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                        href: "https://getmanfred.typeform.com/to/qQt6QXxM",
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("member-get-member.how-it-works.cta")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatures, {
                children: cards.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardInner, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardTitle, {
                                        children: [
                                            card.title,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,paths/* getPublicPath */.A)("/images/memberGetMember/card-title-icon.svg"),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardImage, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: card.image,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardMainContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardDesc, {
                                                children: card.desc
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardRewards, {
                                                children: card.rewards.map(function(reward, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardReward, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: reward.icon,
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: reward.text
                                                                }
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var features_MGMFeatures = (MGMFeatures);

;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/hero/MGMHero.styled.tsx

function MGMHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: center bottom;\n  background-size: cover;\n  padding: 0 ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        " ",
        ";\n    background-size: cover;\n    background-position: center bottom;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    MGMHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MGMHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  z-index: 1;\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-start;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    MGMHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MGMHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  color: ",
        ";\n  line-height: 1.5;\n  text-align: center;\n  margin: auto;\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n    font-size: ",
        ";\n    line-height: 1.4;\n    margin: unset;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    MGMHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MGMHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    MGMHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MGMHero_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    MGMHero_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MGMHero_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n  overflow: hidden;\n  max-width: 100%;\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    MGMHero_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a38cb586-0"
})(MGMHero_styled_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/memberGetMember/bg-hero.svg"), "')");
}, (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a38cb586-1"
})(MGMHero_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl6"));
var StyledHeroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a38cb586-2"
})(MGMHero_styled_templateObject2(), (0,theme/* container */.nC)("xs"), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-a38cb586-3"
})(MGMHero_styled_templateObject3(), (0,theme/* spacing */.W0)("lg"));
var StyledHeroVideoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a38cb586-4"
})(MGMHero_styled_templateObject4());
var StyledHeroVideo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a38cb586-5"
})(MGMHero_styled_templateObject5());

;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/hero/MGMHero.tsx






var MGMHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("member-get-member").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroTitle, {
                            children: t("member-get-member.hero.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: t("member-get-member.hero.desc")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                            href: "#features",
                            variant: "brandTalent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("member-get-member.hero.cta")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroVideoContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroVideo, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: "https://player.vimeo.com/video/810841213?h=d60b4cb5b5&autoplay=1&title=0&byline=0&portrait=0&muted=1",
                            frameBorder: "0",
                            allow: "autoplay; fullscreen; picture-in-picture",
                            allowFullScreen: true
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_MGMHero = (MGMHero);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/info/MGMInfo.styled.tsx

function MGMInfo_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  padding: ",
        " 0;\n  background-size: cover;\n  background-position: center bottom;\n"
    ]);
    MGMInfo_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MGMInfo_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  padding: ",
        " ",
        ";\n  color: ",
        ";\n"
    ]);
    MGMInfo_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MGMInfo_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  margin: auto;\n\n  p {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    MGMInfo_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MGMInfo_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  display: grid;\n  gap: ",
        ";\n  grid-template-columns: minmax(0, 1fr);\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n"
    ]);
    MGMInfo_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MGMInfo_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  background-color: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  transition: opacity 0.3s;\n\n  &:hover {\n    opacity: 0.8;\n    color: inherit;\n  }\n"
    ]);
    MGMInfo_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fba34ddc-0"
})(MGMInfo_styled_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/memberGetMember/bg-info.svg"), "')");
}, (0,theme/* spacing */.W0)("xl4"));
var MGMInfo_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fba34ddc-1"
})(MGMInfo_styled_templateObject1(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("white"));
var MGMInfo_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fba34ddc-2"
})(MGMInfo_styled_templateObject2(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"));
var StyledItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fba34ddc-3"
})(MGMInfo_styled_templateObject3(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"));
var StyledItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-fba34ddc-4"
})(MGMInfo_styled_templateObject4(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("xs"));

;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/info/MGMInfo.tsx






var MGMInfo = function() {
    var t = (0,useI18n/* useI18n */.Q)("member-get-member").t;
    var locale = (0,router.useRouter)().locale;
    var proposalUrl = "https://drive.google.com/file/d/1Pp_3nQyLQs4_IWYKvQYhSkwZtATc_cBp/view?usp=sharing";
    var contractUrl = "https://drive.google.com/file/d/1XqK7d-Gh6fUNHTfhRJo_M7uXHAapHOAE/view?usp=share_link";
    if (locale === "es") {
        proposalUrl = "https://drive.google.com/file/d/1K5KZKJjF7XBZ_4eW_Op5KxMWPFYodxZ_/view?usp=sharing";
        contractUrl = "https://drive.google.com/file/d/1XqK7d-Gh6fUNHTfhRJo_M7uXHAapHOAE/view?usp=share_link";
    }
    if (locale === "en") {
        proposalUrl = "https://drive.google.com/file/d/1Pp_3nQyLQs4_IWYKvQYhSkwZtATc_cBp/view?usp=sharing";
        contractUrl = "https://drive.google.com/file/d/1xLqAReXkblgjtsRP6tctRy3rWaCrCc4u/view?usp=share_link";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MGMInfo_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MGMInfo_styled_StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                            editorial: true,
                            children: t("member-get-member.know-more.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: t("member-get-member.know-more.desc")
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItems, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                            href: proposalUrl,
                            target: "_blank",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/memberGetMember/proposal-icon.svg"),
                                    alt: ""
                                }),
                                t("member-get-member.know-more.proposition")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                            href: contractUrl,
                            target: "_blank",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/memberGetMember/contracts-icon.svg"),
                                    alt: ""
                                }),
                                t("member-get-member.know-more.contracts")
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var info_MGMInfo = (MGMInfo);

;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/trade/MGMTrade.styled.tsx

function MGMTrade_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    MGMTrade_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MGMTrade_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        " ",
        ";\n  text-align: center;\n"
    ]);
    MGMTrade_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MGMTrade_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n\n  p {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    MGMTrade_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MGMTrade_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  display: grid;\n  gap: ",
        ";\n  grid-template-columns: minmax(0, 1fr);\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n"
    ]);
    MGMTrade_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MGMTrade_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  h4 {\n    font-size: ",
        ";\n    margin: 0;\n    font-weight: ",
        ";\n\n    &::before {\n      content: '';\n      display: block;\n      margin: 0 auto ",
        ";\n      width: ",
        ";\n      height: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n\n  img {\n    max-width: 11.25rem;\n    margin: auto;\n  }\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    MGMTrade_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MGMTrade_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.428;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  span:first-of-type {\n    font-size: ",
        ";\n    line-height: 1.333;\n    text-transform: uppercase;\n    letter-spacing: 0.25em;\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    MGMTrade_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var MGMTrade_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3143989b-0"
})(MGMTrade_styled_templateObject(), (0,theme/* color */.$_)("sand_100"));
var MGMTrade_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3143989b-1"
})(MGMTrade_styled_templateObject1(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"));
var MGMTrade_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3143989b-2"
})(MGMTrade_styled_templateObject2(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"));
var MGMTrade_styled_StyledItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3143989b-3"
})(MGMTrade_styled_templateObject3(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* screen */.sp)("md"));
var MGMTrade_styled_StyledItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3143989b-4"
})(MGMTrade_styled_templateObject4(), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("sm"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("cyan_500"));
var StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3143989b-5"
})(MGMTrade_styled_templateObject5(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_subtle"));

;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/sections/trade/MGMTrade.tsx









var MGMTrade = function() {
    var t = (0,useI18n/* useI18n */.Q)("member-get-member").t;
    var items = [
        {
            title: t("member-get-member.fredcoins.manfredite.title"),
            image: (0,paths/* getPublicPath */.A)("/images/memberGetMember/reward5.svg"),
            fredcoins: t("member-get-member.fredcoins.manfredite.fredcoins-title"),
            desc: t("member-get-member.fredcoins.manfredite.desc")
        },
        {
            title: t("member-get-member.fredcoins.company.title"),
            image: (0,paths/* getPublicPath */.A)("/images/memberGetMember/reward5.svg"),
            fredcoins: t("member-get-member.fredcoins.company.fredcoins-title"),
            desc: t("member-get-member.fredcoins.company.desc")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MGMTrade_styled_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MGMTrade_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MGMTrade_styled_StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            as: "h3",
                            editorial: true,
                            children: t("member-get-member.fredcoins.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "member-get-member",
                            i18nKey: "member-get-member.fredcoins.desc"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MGMTrade_styled_StyledItems, {
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MGMTrade_styled_StyledItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item.image,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesc, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.fredcoins
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: item.desc
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                    href: "https://getmanfred.typeform.com/to/qQt6QXxM",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faCheckCircle */.f8k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("member-get-member.fredcoins.cta")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var trade_MGMTrade = (MGMTrade);

;// CONCATENATED MODULE: ./components/marketingSite/memberGetMember/MGMComponent.tsx











var MGMComponent = function() {
    var t = (0,useI18n/* useI18n */.Q)("member-get-member").t;
    var faqs = [
        {
            question: t("member-get-member.faqs.faq1.question"),
            active: true,
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "member-get-member",
                i18nKey: "member-get-member.faqs.faq1.answer"
            }),
            renderComponent: true
        },
        {
            question: t("member-get-member.faqs.faq2.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "member-get-member",
                i18nKey: "member-get-member.faqs.faq2.answer"
            }),
            renderComponent: true
        },
        {
            question: t("member-get-member.faqs.faq3.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "member-get-member",
                i18nKey: "member-get-member.faqs.faq3.answer"
            }),
            renderComponent: true
        },
        {
            question: t("member-get-member.faqs.faq4.question"),
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "member-get-member",
                i18nKey: "member-get-member.faqs.faq4.answer"
            }),
            renderComponent: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        pageVariant: "light",
        hasScrollTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_MGMHero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(features_MGMFeatures, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(trade_MGMTrade, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(info_MGMInfo, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFaqsWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                        faqs: faqs,
                        title: t("member-get-member.faqs.title"),
                        desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                            ns: "member-get-member",
                            i18nKey: "member-get-member.faqs.desc",
                            components: {
                                mail: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:team@getmanfred.com"
                                })
                            }
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var memberGetMember_MGMComponent = (MGMComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./pages/member-get-member.tsx







var MemberGetMemberPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("member-get-member").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("member-get-member.page_title"),
                url: app_urls/* APP_URLS.memberGetMember */.uu.memberGetMember,
                desc: t("member-get-member.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_member_get_member.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(memberGetMember_MGMComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var member_get_member = (MemberGetMemberPage);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,7265,9774,2888,179], function() { return __webpack_exec__(75336); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);